function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.5 10.625a2.125 2.125 0 1 0 0-4.25 2.125 2.125 0 0 0 0 4.25z",
  stroke: "#2473C1",
  strokeWidth: 1.417,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.742 10.625a1.169 1.169 0 0 0 .234 1.29l.042.042a1.417 1.417 0 1 1-2.005 2.004l-.042-.042a1.169 1.169 0 0 0-1.29-.234 1.169 1.169 0 0 0-.707 1.07v.12a1.417 1.417 0 1 1-2.834 0v-.064a1.169 1.169 0 0 0-.765-1.07 1.168 1.168 0 0 0-1.289.235l-.043.042a1.417 1.417 0 1 1-2.004-2.005l.042-.042a1.17 1.17 0 0 0 .234-1.29 1.168 1.168 0 0 0-1.07-.708h-.12a1.417 1.417 0 1 1 0-2.833h.064a1.169 1.169 0 0 0 1.07-.765 1.169 1.169 0 0 0-.234-1.29l-.043-.042A1.417 1.417 0 1 1 4.987 3.04l.042.042a1.169 1.169 0 0 0 1.29.234h.056a1.169 1.169 0 0 0 .708-1.07v-.12a1.417 1.417 0 1 1 2.834 0v.064a1.169 1.169 0 0 0 .708 1.07 1.169 1.169 0 0 0 1.29-.234l.042-.043a1.417 1.417 0 1 1 2.004 2.005l-.042.042a1.169 1.169 0 0 0-.234 1.29v.056a1.168 1.168 0 0 0 1.07.708h.12a1.417 1.417 0 0 1 0 2.834h-.064a1.17 1.17 0 0 0-1.07.708v0z",
  stroke: "#2473C1",
  strokeWidth: 1.417,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

const SvgGearSmall = props => React.createElement("svg", _extends({
  width: 17,
  height: 17,
  fill: "none"
}, props), _ref, _ref2);

export default SvgGearSmall;